import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import { buildSourceURL } from '../../utils/functions';
import { getMealsToChange, changeMeal } from '../../actions/menus';
import DishDetails from './DishDetails';
import styles from './DishesPage.module.css';

const ChangePage = (props) => {
  const { 
    day, 
    meal,
    mealsToChange,
    getMealsToChange,
    changeMeal,
    onBack,
    onChange,
  } = props;

  const [showDish, setShowDish] = useState(false);
   
  console.log('===day, meal', mealsToChange);

  useEffect(() => {
    getMealsToChange(day, meal);
  }, []);

  const changeMealHandler = (dishId) => {
    const changeMealData = {
      day,
      meal,
      dish_id: dishId,
    };

    changeMeal(changeMealData, onChange);
  };

  const onBackHandler = () => {
    setShowDish(false);
  };

  if (showDish) {
    return (
      <DishDetails 
        dishId={showDish.id}
        onBack={onBackHandler}
      >
        <button 
          className={cn(styles.transparentButton, styles.mobileHidden)}
          onClick={onBackHandler}
        >
          Back
        </button>
        <button 
          className={styles.greenButton} 
          onClick={() => changeMealHandler(showDish.id)}
        >
          Choose this dish
        </button>
      </DishDetails>
    );
  }

  return (
    <div className={cn(styles.wrapper, styles.changeMealWrapper)}>
      <div className={styles.backButton} onClick={onBack} />
      <div className={styles.changeMealContent}>
        <div className={styles.title}>
          Choose dish
        </div>
        <div className={styles.changeMealList}>
          {mealsToChange.map((dish) => (
            <div 
              key={dish.id} 
              className={styles.changeMealItem}
              onClick={() => setShowDish(dish)}
            >
              <img
                className={styles.dishImage}
                src={buildSourceURL(dish.image)} 
                alt={dish.name} 
              />
              <div>
                <div className={styles.dishName}>
                  {dish.name}
                </div>
                <div className={styles.dishCalories}>
                  {+dish.calories?.toFixed(1)} kcal
                </div>
                <div 
                  className={styles.changeMenuLink}
                  onClick={(event) => {
                    event.stopPropagation();
                    changeMealHandler(dish.id);
                  }}
                >
                  Choose this dish
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  mealsToChange: state.menus.mealsToChange,
});

const mapDispatchToProps = {
  getMealsToChange,
  changeMeal,
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangePage);